import { AUTHOR_LIST_GQL } from './gql';
import { apolloClient } from '../client';
import { Author } from '../types.generated';

export const authorListQuery = async (): Promise<Author[] | null> => {
  const response = await apolloClient.query<{ authors: Author[] }>({
    query: AUTHOR_LIST_GQL,
    variables: {},
    fetchPolicy: 'network-only',
  });

  return response.data ? response.data.authors : null;
};
